/**
 * Bir varyantta seçili gelmesi gereken beden index'i.
 *
 * Tek beden varsa kullanıcı seçmeden aktif olur — "Sepete Ekle" gereksiz bir
 * beden seçme adımı istemez. Birden fazla beden varsa hiçbiri ön-seçili gelmez
 * (-1); seçimi kullanıcının kendisi yapar, aksi halde yanlış beden sepete gider.
 *
 * Tek beden stokta değilse yine seçilmez — stoksuz varyant sepete gitmesin.
 */
export const getDefaultSizeIndex = (
  sizes?: { stock: number }[] | null,
): number => {
  if (!sizes || sizes.length !== 1) return -1;
  return sizes[0].stock > 0 ? 0 : -1;
};
